var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "23px",
    viewBox: "0 0 28 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9servation-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9servation-tunnel-FCB02-012-Copy",
    transform: "translate(-174.000000, -297.000000)",
    fill: "#262957",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "conditions-1-copy",
    transform: "translate(40.000000, 285.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-valider",
    transform: "translate(124.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4708456,12.9395462 C35.1703189,12.0846714 36.430367,11.9586937 37.2852417,12.6581671 C38.1401165,13.3576404 38.2660942,14.6176885 37.5666209,15.4725632 L21.5607333,35.034465 L10.9169369,22.9523979 C10.18678,22.1235766 10.2667632,20.8597751 11.0955845,20.1296182 C11.9244057,19.3994613 13.1882072,19.4794446 13.9183642,20.3082658 L21.4481284,28.8555091 L34.4708456,12.9395462 Z",
    id: "Path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValider);
export default __webpack_public_path__ + "static/media/valider.d5fa5f4428c44b6ddca333d38e9b4ba0.svg";
export { ForwardRef as ReactComponent };